export const removeGoogleTranslatedContent = (content: string) => {
  if (content && content.includes('(Translated by Google)')) {
    const translatedRegex = /(\n*)\(Translated by Google\)[\s\S]*?(?:\(Original\)\n?|$)/gi;
    content = content.replace(translatedRegex, '');
  }
  return content;
};
